export function getUserId() {
  return window['dataLayer']?.userID || ''
}
